import styled from "styled-components";

export const ContainerSpinner = styled.div`
  display: flex;
  height: 400px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ContainerBanner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .nav-arrow{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 101;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    opacity: 0.6;
    transition: all 0.2s ease-in-out;

    img{
      width: 16px;
      height: 16px;
      pointer-events: none;
    }

    svg{
      width: 20px;
      height: 20px;
      color: ${props => props.theme.colors.primary};
      pointer-events: none;
    }

    &:hover{
      opacity: 1;
      transform: translateY(-50%) scale(1.08);
    }
  }

  .nav-prev{
    left: 16px;
  }

  .nav-next{
    right: 16px;
  }

  .dots{
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 101;
    display: inline-flex;
    list-style: none;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 0;

    li{
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      span{
        width: 8px;
        height: 8px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.6);
        transition: all 0.2s ease-in-out;
        &.active{
          width: 32px;
          background: ${(props) => props.theme.colors.primary};
        }
      }
    }
  }

`;

export const ContainerHighlights = styled.div`
  padding: 20px 24px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  background: ${(props) => props.theme.colors.white};
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(20, 60, 151, 0.08);

  .highlight-card {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 0 0 auto;
    min-width: max-content;
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }

  .highlight-image {
    display: block;
    width: 44px;
    min-width: 44px;
    height: 44px;
    object-fit: contain;
    pointer-events: none;
  }

  .highlight-text {
    display: flex;
    flex-direction: column;
    text-align: left;
    line-height: 1.25;
  }

  .highlight-text strong {
    font-size: 16px;
    font-weight: 700;
    color: "#000000";
    white-space: nowrap;
  }

  .highlight-text span {
    font-size: 14px;
    color: ${(props) => props.theme.colors.neutral600};
    white-space: nowrap;
  }

    @media (max-width: 1440px){
    margin-left: 16px;
    margin-right: 16px;
  }
`;
